<!-- Desktop `skelLabels`; tablet 768pt body + shared footer actions; mobile 390pt. -->
<div class="get-labels-skeleton" aria-hidden="true" data-testid="get-labels-skeleton">
  <div class="get-labels-skeleton__desktop">
    <app-skeleton-block width="420" height="30" />

    <div class="get-labels-skeleton__notice">
      <app-skeleton-block width="20" height="20" radius="circle" [animated]="false" />
      <app-skeleton-block width="560" height="12" tone="secondary" />
    </div>

    <div class="get-labels-skeleton__toolbar">
      <app-skeleton-block width="180" height="14" tone="secondary" />
      <app-skeleton-block width="188" height="40" radius="card" />
    </div>

    <div class="get-labels-skeleton__label-card">
      <app-skeleton-block width="220" height="26" />
      <app-skeleton-block width="240" height="16" />
      <app-skeleton-block width="70%" height="12" tone="secondary" />
      <div class="get-labels-skeleton__doc-header">
        <app-skeleton-block width="96" height="12" [animated]="false" />
        <app-skeleton-block width="110" height="12" [animated]="false" />
        <div class="get-labels-skeleton__doc-action">
          <app-skeleton-block width="128" height="12" [animated]="false" />
        </div>
      </div>
      <div class="get-labels-skeleton__doc-row">
        <app-skeleton-block width="106" height="138" radius="card" tone="emphasis" />
        <app-skeleton-block width="216" height="12" tone="secondary" />
        <div class="get-labels-skeleton__doc-action">
          <app-skeleton-block width="156" height="44" radius="card" />
        </div>
      </div>
    </div>

    <div class="get-labels-skeleton__costs-card">
      <app-skeleton-block width="220" height="26" />
      <div class="get-labels-skeleton__costs-grid get-labels-skeleton__costs-grid--desktop">
        <div class="get-labels-skeleton__costs-arrival">
          <app-skeleton-block width="190" height="15" />
          <app-skeleton-block height="118" radius="card" tone="emphasis" />
        </div>
        <div class="get-labels-skeleton__costs-lines">
          @for (line of desktopCostLinePlaceholders; track line) {
            <div class="get-labels-skeleton__costs-row">
              <app-skeleton-block width="130" height="11" tone="secondary" />
              <app-skeleton-block width="58" height="11" tone="secondary" />
            </div>
          }
          <div class="get-labels-skeleton__divider"></div>
          <div class="get-labels-skeleton__costs-row">
            <app-skeleton-block width="68" height="15" />
            <app-skeleton-block width="76" height="15" />
          </div>
        </div>
        <div class="get-labels-skeleton__costs-payment">
          <app-skeleton-block width="150" height="14" />
          <div class="get-labels-skeleton__payment-row">
            <app-skeleton-block width="78" height="48" radius="card" tone="emphasis" />
            <div class="get-labels-skeleton__payment-copy">
              <app-skeleton-block width="92" height="11" tone="secondary" />
              <app-skeleton-block width="108" height="11" tone="secondary" />
            </div>
          </div>
          <app-skeleton-block width="130" height="14" />
          <app-skeleton-block width="160" height="11" tone="secondary" />
          <app-skeleton-block width="96" height="11" tone="secondary" />
        </div>
      </div>
    </div>

    <div class="get-labels-skeleton__notice get-labels-skeleton__notice--secondary">
      <app-skeleton-block width="20" height="20" radius="circle" [animated]="false" />
      <app-skeleton-block width="560" height="12" tone="secondary" />
    </div>

    <div class="get-labels-skeleton__divider"></div>
    <div class="get-labels-skeleton__actions">
      <app-skeleton-block width="178" height="46" radius="card" tone="secondary" />
      <app-skeleton-block width="226" height="46" radius="card" />
    </div>
  </div>

  <!-- Tablet 768pt: label/estimate body + divider/actions for page parity (no secondary banner). -->
  <div class="get-labels-skeleton__tablet">
    <app-skeleton-block width="420" height="30" />

    <div class="get-labels-skeleton__notice get-labels-skeleton__notice--tablet">
      <app-skeleton-block width="22" height="22" radius="circle" [animated]="false" />
      <div class="get-labels-skeleton__notice-copy">
        @for (width of tabletNoticeLineWidths; track width) {
          <app-skeleton-block [width]="width" height="12" tone="secondary" />
        }
      </div>
    </div>

    <div class="get-labels-skeleton__toolbar">
      <app-skeleton-block width="190" height="14" tone="secondary" />
      <app-skeleton-block width="194" height="46" radius="card" tone="secondary" />
    </div>

    <div class="get-labels-skeleton__label-card get-labels-skeleton__label-card--tablet">
      <app-skeleton-block width="232" height="28" />
      <app-skeleton-block width="300" height="18" />
      <app-skeleton-block width="92%" height="12" tone="secondary" />
      <app-skeleton-block width="54%" height="12" tone="secondary" />
      <div class="get-labels-skeleton__doc-header get-labels-skeleton__doc-header--tablet">
        <app-skeleton-block width="96" height="12" [animated]="false" />
        <div class="get-labels-skeleton__doc-mid get-labels-skeleton__doc-mid--header">
          <app-skeleton-block width="106" height="12" [animated]="false" />
        </div>
        <div class="get-labels-skeleton__doc-action">
          <app-skeleton-block width="132" height="12" [animated]="false" />
        </div>
      </div>
      <div class="get-labels-skeleton__doc-row get-labels-skeleton__doc-row--tablet">
        <app-skeleton-block width="100" height="140" radius="shell" tone="emphasis" />
        <div class="get-labels-skeleton__doc-mid">
          <app-skeleton-block width="200" height="12" tone="secondary" />
        </div>
        <div class="get-labels-skeleton__doc-action">
          <app-skeleton-block width="150" height="48" radius="card" />
        </div>
      </div>
    </div>

    <div class="get-labels-skeleton__costs-card get-labels-skeleton__costs-card--tablet">
      <app-skeleton-block width="290" height="26" />
      <div class="get-labels-skeleton__costs-grid get-labels-skeleton__costs-grid--tablet">
        <div class="get-labels-skeleton__costs-arrival">
          <app-skeleton-block width="180" height="15" />
          <app-skeleton-block height="128" radius="shell" tone="emphasis" />
        </div>
        <div class="get-labels-skeleton__costs-lines">
          @for (line of tabletCostLinePlaceholders; track line) {
            <div class="get-labels-skeleton__costs-row">
              <app-skeleton-block width="140" height="11" tone="secondary" />
              <app-skeleton-block width="56" height="11" tone="secondary" />
            </div>
          }
          <div class="get-labels-skeleton__divider get-labels-skeleton__divider--strong"></div>
          <div class="get-labels-skeleton__costs-row">
            <app-skeleton-block width="66" height="15" />
            <app-skeleton-block width="76" height="15" />
          </div>
        </div>
      </div>
      <div class="get-labels-skeleton__costs-payment get-labels-skeleton__costs-payment--tablet">
        <app-skeleton-block width="150" height="14" />
        <div class="get-labels-skeleton__payment-row">
          <app-skeleton-block width="78" height="48" radius="card" tone="emphasis" />
          <div class="get-labels-skeleton__payment-copy">
            <app-skeleton-block width="92" height="11" tone="secondary" />
            <app-skeleton-block width="108" height="11" tone="secondary" />
          </div>
        </div>
        <app-skeleton-block class="get-labels-skeleton__payment-gap" width="126" height="14" />
        <app-skeleton-block width="158" height="11" tone="secondary" />
        <app-skeleton-block width="92" height="11" tone="secondary" />
      </div>
    </div>

    <div class="get-labels-skeleton__divider"></div>
    <div class="get-labels-skeleton__actions">
      <app-skeleton-block width="178" height="46" radius="card" tone="secondary" />
      <app-skeleton-block width="226" height="46" radius="card" />
    </div>
  </div>

  <div class="get-labels-skeleton__mobile">
    <div class="get-labels-skeleton__mobile-title">
      <app-skeleton-block width="100%" height="30" />
      <app-skeleton-block width="26%" height="30" />
    </div>

    <div class="get-labels-skeleton__mobile-notice">
      <app-skeleton-block width="22" height="22" radius="circle" [animated]="false" />
      <div class="get-labels-skeleton__mobile-notice-copy">
        @for (width of mobileNoticeLineWidths; track width) {
          <app-skeleton-block [width]="width" height="12" tone="secondary" />
        }
      </div>
      <app-skeleton-block width="22" height="22" radius="circle" [animated]="false" />
    </div>

    <div class="get-labels-skeleton__mobile-details-link">
      <app-skeleton-block width="196" height="15" />
      <app-skeleton-block width="14" height="14" radius="stub" [animated]="false" />
    </div>

    <app-skeleton-block height="50" radius="card" tone="secondary" />

    <div class="get-labels-skeleton__mobile-label-card">
      <app-skeleton-block width="216" height="28" />
      <app-skeleton-block width="272" height="20" />
      <div class="get-labels-skeleton__mobile-helpers">
        @for (width of mobileHelperLineWidths; track width) {
          <app-skeleton-block [width]="width" height="12" tone="secondary" />
        }
      </div>
      <div class="get-labels-skeleton__mobile-doc-badge">
        <app-skeleton-block width="108" height="16" />
      </div>
      <div class="get-labels-skeleton__mobile-thumb-wrap">
        <app-skeleton-block width="110" height="154" radius="shell" tone="emphasis" />
      </div>
      <div class="get-labels-skeleton__mobile-thumb-caption">
        <app-skeleton-block width="216" height="13" tone="secondary" />
      </div>
      <app-skeleton-block height="52" radius="card" />
    </div>

    <div class="get-labels-skeleton__mobile-estimate">
      <app-skeleton-block width="240" height="26" />
      <app-skeleton-block width="190" height="17" />
      <app-skeleton-block height="138" radius="shell" tone="emphasis" />
    </div>
  </div>
</div>
